<template>
    <v-dialog persistent v-model="show" max-width="300">
  <v-card
    width="300"
    class="text-xs-center"
  >
    <v-card-title
      class="tituloCustom justify-center"
    >
      O que você achou dessa campanha?
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <div class="text-center mt-12">
    <v-rating
      v-model="campaignRating.rate"
      background-color="indigo lighten-3"
      color="indigo"
      size="30"
    ></v-rating>
      </div>
      <v-textarea
              v-model="campaignRating.notes"
              name="input-7-1"
              value
              class="menuTextbox px-2 pt-2 pb-1"
              placeholder="Digite aqui sua recomendação"
              rows="3"
        ></v-textarea>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions class="justify-center">
      <v-btn  round
        small
        outline
        flat="flat"
        @click.stop="show = false"
        class="text-lowercase"
        >Não, obrigado</v-btn>
      <v-btn
         round
        small
        depressed
        dark
        class="text-lowercase"
        color="#099AB1"
        @click.stop="enviarAvaliacao"
      >
        Avaliar agora
      </v-btn>
    </v-card-actions>
  </v-card>
    </v-dialog>
</template>

<script>
import { EventBus } from '@/event-bus.js';
import { APIService } from '@/resources/campanha.js';

const api = new APIService();

export default {
  data: () => ({
    campaignRating: {
      rate: 1,
      notes: null,
    },
  }),
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  props: {
    value: Boolean,
    campaign: Object,
  },
  methods: {
    emitSnackBar() {
      const snackBar = {};
      snackBar.text = 'Avaliação computada com sucesso!';
      snackBar.value = true;
      EventBus.$emit('activeSnackBar', snackBar);
    },
    async enviarAvaliacao() {
      this.campaignRating.sellerId = this.$store.state.profile.id;
      this.campaignRating.customerId = this.$store.state.customer.id;
      this.campaignRating.campaignId = this.campaign.id;
      this.campaignRating.createdAt = new Date();
      console.log(this.campaignRating);
      await api.postCampaignRating(this.campaignRating);
      this.campaignRating = { rate: 1, notes: null };
      this.show = false;
      this.emitSnackBar();
    },
  },
};
</script>

<style scoped>
.v-card {
  box-shadow: none;
  border-radius: 10px;
}

.theme--light.v-sheet {
  border: 1px solid #e0e0e0;
}

.tituloCustom{
  font-weight: bold;
  font-size: 1em;
  color: grey;
}

.menuTextbox {
  font-size: 12px;
}
</style>
